import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ZuiMaterialStackModule } from '@zerops/zui/material-stack';
import { ZuiMaterialFormStackModule } from '@zerops/zui/material-form-stack';
import { LocalSearchFieldComponent } from './local-search-field.component';

@NgModule({
  declarations: [ LocalSearchFieldComponent ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ZuiMaterialStackModule,
    ZuiMaterialFormStackModule
  ],
  exports: [ LocalSearchFieldComponent ]
})
export class LocalSearchFieldModule {

}
